import type { NewsItem } from '../types/content';

export const news: NewsItem[] = [
  {
    id: 'news-001',
    title: '《星海拾荒者》动画化确定，2027年春季开播',
    cover: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20space%20scavenger%20girl%20floating%20before%20a%20giant%20ruined%20spaceship%20in%20a%20green%20nebula%2C%20cinematic%20cel%20shaded%20illustration%2C%20dramatic%20lighting%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-001&orientation=landscape',
    category: '新番',
    date: '2026-10-12',
    source: '漫蛙资讯',
    author: '编辑部·青鸟',
    summary: '人气太空冒险漫画《星海拾荒者》正式宣布动画化，由新锐工作室操刀，预计2027年春季与观众见面。',
    content: [
      '在昨日举行的线上发布会上，官方正式宣布人气漫画《星海拾荒者》将改编为电视动画，并公开了首支先导预告与主视觉图。',
      '本次动画化由新锐工作室承制，原作者深蓝绘影将全程参与系列构成与角色设定监修，力求还原漫画中那些令人惊叹的星际场景。',
      '先导预告中，主角拾荒者少女从坠毁战舰中救出机械少年的经典桥段被完整还原，配合恢弘的管弦配乐，弹幕瞬间被“泪目”刷屏。',
      '官方表示，第一季将覆盖原作前八卷内容，预计2027年春季开播，更多声优信息将于年底陆续公布。',
    ],
    tags: ['星海拾荒者', '动画化', '新番'],
  },
  {
    id: 'news-002',
    title: '2026秋季新番中期盘点：本季最值得追的五部作品',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20collage%20of%20several%20anime%20scenes%20for%20autumn%20season%2C%20magical%20convenience%20store%20and%20school%20and%20fantasy%20night%20market%2C%20vibrant%20cel%20shaded%20art%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-002&orientation=landscape',
    category: '评论',
    date: '2026-10-11',
    source: '漫蛙评测组',
    author: '评测员·阿岩',
    summary: '秋季新番已播出过半，编辑部挑选出本季最值得追看的五部作品，从作画水准到叙事节奏一次聊透。',
    content: [
      '每到换季，观众最头疼的就是“这一季到底看什么”。我们整理了开播至今的口碑与作画表现，为大家筛出五部不容错过的作品。',
      '从治愈系的《魔法便利店》到热血向的《爆改系统上线》，本季作品类型相当均衡，几乎没有明显的断层。',
      '值得一提的是，多部作品在演出层面尝试了更大胆的镜头语言，尤其是《雾都料理铺》的深夜长镜头，被不少观众称为“本季最佳”。',
      '当然，评判标准因人而异，欢迎大家在评论区留下你心中的本季最佳。',
    ],
    tags: ['新番', '盘点', '秋季番'],
  },
  {
    id: 'news-003',
    title: '国漫出海新进展：多部作品登陆海外主流平台',
    cover: 'https://readdy.ai/api/search-image?query=modern%20illustration%20of%20chinese%20comic%20books%20and%20tablet%20showing%20webcomic%20pages%20flying%20across%20a%20globe%2C%20bright%20green%20and%20orange%20accents%2C%20clean%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-003&orientation=landscape',
    category: '专题报道',
    date: '2026-10-10',
    source: '漫蛙产业观察',
    author: '观察员·林晚',
    summary: '随着多部国产漫画与海外平台达成合作，国漫出海正从单点试水走向规模化运营。',
    content: [
      '过去一年，国漫的海外发行渠道明显提速。多部在国内拥有高人气的作品，陆续登陆海外主流漫画平台，并同步推出多语言版本。',
      '业内人士指出，国漫的题材优势在于“日常感”与“烟火气”，这正是海外读者好奇并愿意买单的部分。',
      '不过挑战同样存在：翻译质量、更新节奏与本地化运营，仍是决定一部作品能否真正“走出去”的关键。',
      '可以预见，未来两年将有更多国漫加入出海队列，而如何讲好一个跨越文化的故事，是所有创作者的共同课题。',
    ],
    tags: ['国漫', '出海', '行业'],
  },
  {
    id: 'news-004',
    title: '《雾都料理铺》单行本销量突破300万册',
    cover: 'https://readdy.ai/api/search-image?query=stacks%20of%20manga%20volumes%20of%20a%20cozy%20food%20comic%20on%20a%20wooden%20table%20with%20warm%20lantern%20light%20and%20steaming%20bowl%2C%20warm%20amber%20and%20green%20tones%2C%20editorial%20photography%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-004&orientation=landscape',
    category: '新闻',
    date: '2026-10-09',
    source: '漫蛙资讯',
    author: '编辑部·青鸟',
    summary: '治愈系人气作品《雾都料理铺》官方宣布，单行本累计销量正式突破300万册，并追加印刷新版特装版。',
    content: [
      '官方于今日公布，《雾都料理铺》单行本累计发行量突破300万册，成为近年来少见的靠“慢节奏”突围的作品。',
      '作者小林暖在感谢信中表示，最初只是想画一个“能让人安静下来”的故事，没想到会收获这么多共鸣。',
      '为回馈读者，官方将推出收录未公开番外的新版特装版，并附赠限定食谱小册子。',
      '据悉，新版特装版将于下月正式发售，实体书店与线上渠道同步开启预约。',
    ],
    tags: ['雾都料理铺', '单行本', '销量'],
  },
  {
    id: 'news-005',
    title: '深度解析：为什么“日常系”作品越来越受欢迎？',
    cover: 'https://readdy.ai/api/search-image?query=calm%20illustration%20of%20a%20quiet%20japanese%20town%20street%20at%20dusk%20with%20warm%20windows%20and%20a%20cat%20on%20the%20wall%2C%20gentle%20green%20and%20amber%20palette%2C%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-005&orientation=landscape',
    category: '评论',
    date: '2026-10-08',
    source: '漫蛙评测组',
    author: '评测员·阿岩',
    summary: '没有拯救世界，也没有惊天反转，日常系作品凭什么俘获越来越多观众？本文试着从情绪价值聊起。',
    content: [
      '在过去，衡量一部作品是否“好看”，往往看它是否足够宏大、足够刺激。而近几年，节奏缓慢的日常系作品却悄然占据了一席之地。',
      '一个重要原因，是观众对“情绪价值”的需求在上升。当现实生活足够疲惫时，一碗热汤、一个午后的阳光，比热血的对决更能治愈人心。',
      '另一方面，日常系作品往往在细节上更加考究：一个眼神、一句台词，都可能成为打动观众的关键。',
      '这或许也提醒创作者：好故事不一定要惊天动地，能把平凡日常画得动人，本身就是一种了不起的能力。',
    ],
    tags: ['日常系', '评论', '情绪价值'],
  },
  {
    id: 'news-006',
    title: '《爆改系统上线》更新破纪录，单话阅读量破千万',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20illustration%20of%20a%20young%20man%20breaking%20through%20holographic%20green%20game%20interface%20panels%20with%20speed%20lines%2C%20energetic%20webcomic%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-006&orientation=landscape',
    category: '新闻',
    date: '2026-10-07',
    source: '漫蛙资讯',
    author: '编辑部·青鸟',
    summary: '人气都市热血漫画《爆改系统上线》最新一话上线24小时阅读量突破千万，登上平台热度榜首。',
    content: [
      '《爆改系统上线》最新一话于昨晚上线，仅用24小时，单话阅读量便突破一千万，刷新了平台同类作品的纪录。',
      '这一话中，主角终于完成了从“外卖小哥”到“系统持有者”的关键转折，剧情张力拉满，读者直呼“一口气看到凌晨”。',
      '作者键盘侠本侠在社交平台上透露，接下来的剧情将进入全新篇章，主角将面对更强大的对手。',
      '目前该作在漫蛙平台热度榜稳居第一，收藏数也突破了57万。',
    ],
    tags: ['爆改系统上线', '更新', '热度'],
  },
  {
    id: 'news-007',
    title: '新作预告：三部将在明年春季登场的高期待作品',
    cover: 'https://readdy.ai/api/search-image?query=bright%20illustration%20of%20three%20glowing%20manga%20book%20covers%20standing%20side%20by%20side%20on%20a%20cloud%20of%20light%2C%20spring%20green%20and%20amber%20palette%2C%20clean%20flat%20editorial%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-007&orientation=landscape',
    category: '新番',
    date: '2026-10-06',
    source: '漫蛙资讯',
    author: '编辑部·青鸟',
    summary: '各大出版方陆续公布明年春季的新作阵容，我们挑出三部最受期待的作品提前为大家做个小预告。',
    content: [
      '虽然距离明年春季还有一段时间，但新作的消息已经陆续放出，不少读者已经开始期待。',
      '第一部是由《刀锋记事簿》作者寒山客带来的全新古风作品，延续了其一贯的硬朗画风与扎实叙事。',
      '第二部是《深海图书馆》团队筹备多年的科幻长篇，主题围绕着记忆与遗忘展开。',
      '第三部则是备受瞩目的跨界合作，具体信息官方暂未完全公开，我们将持续关注。',
    ],
    tags: ['新作', '预告', '春季'],
  },
  {
    id: 'news-008',
    title: '如何挑选一部适合自己的漫画？五个实用小技巧',
    cover: 'https://readdy.ai/api/search-image?query=neat%20flat%20illustration%20of%20a%20hand%20picking%20one%20manga%20book%20from%20a%20shelf%20full%20of%20colorful%20comics%2C%20tips%20and%20list%20motif%2C%20green%20and%20orange%20accents%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-008&orientation=landscape',
    category: '资讯',
    date: '2026-10-05',
    source: '漫蛙攻略组',
    author: '攻略员·小满',
    summary: '面对琳琅满目的作品不知从何下手？这里有五个实用小技巧，帮你快速找到那部“对味”的漫画。',
    content: [
      '漫画作品越来越多，选起来反而更难了。其实只要掌握几个小方法，就能大幅降低“踩雷”的概率。',
      '第一，先看标签。标签往往比简介更能直接反映作品的核心气质。',
      '第二，试读前三话。大多数作品会在前三话内展现出它的节奏与风格。',
      '第三，参考同好推荐。榜单和收藏数是有意义的，但找到口味相近的人推荐往往更准。',
      '第四，允许自己弃坑。不喜欢就换下一部，阅读本该是件轻松的事。',
    ],
    tags: ['攻略', '选漫', '技巧'],
  },
  {
    id: 'news-009',
    title: '经典回顾：那些年的高分“神作”为何依然能打？',
    cover: 'https://readdy.ai/api/search-image?query=nostalgic%20illustration%20of%20classic%20manga%20volumes%20glowing%20with%20soft%20light%20on%20a%20dark%20shelf%2C%20timeless%20mood%2C%20green%20and%20amber%20accents%2C%20editorial%20style%2C%20wide%20landscape%20composition&width=900&height=560&seq=news-cover-009&orientation=landscape',
    category: '专题报道',
    date: '2026-10-03',
    source: '漫蛙专题组',
    author: '专题员·老白',
    summary: '被反复回味的老作品，凭什么历久弥新？本期专题，我们重新翻开了几部当年的高分“神作”。',
    content: [
      '每隔一段时间，总会有几部老作品被重新推上讨论热榜。它们没有炫技，却总能在多年后依然打动人。',
      '原因或许在于，这些作品讲的是“人”本身——成长、失去、坚持与和解，这些主题不会随时间过时。',
      '另一方面，扎实的分镜与克制的叙事，让它们经得起反复阅读，每次重看都能发现新的细节。',
      '经典之所以为经典，不是因为年代久远，而是因为它永远有话想对当下的你说。',
    ],
    tags: ['经典', '回顾', '神作'],
  },
];